/**
 * Grid alignment Script
 */
{
    window.setGridHeight = (selector) => {
      let gridOffsets = [];
      let gridRowOffsets = []
  
      gridOffsets = Array.from(document.querySelectorAll(selector)).map((element,index) => {
        let grid = element.closest('.js-card-wrapper') || element.closest('[data-equal]');
        element.removeAttribute('style');
        return {
          selector:element,
          selectorHeight: element.offsetHeight,
          offsetTop: grid.offsetTop,
        }
      });
  
      let offsets = gridOffsets.map(element => element.offsetTop);
      gridRowOffsets = [...new Set(offsets)];
  
      gridRowOffsets.forEach(rowOffset => {
        let rowGrids = gridOffsets.filter(grid => (grid.offsetTop == rowOffset));
        let comanElementHeight = Math.max.apply(Math,(rowGrids.map(ele => ele.selectorHeight)));
        rowGrids.forEach(grid => {
          grid.selector.style.minHeight = comanElementHeight+'px';
        });
      });
    }
  
   setTimeout(() => {
      window.matchHeightCallback();
    }, 2000)
    
    window.addEventListener('resize', function(event){
      window.matchHeightCallback();
    });
  
    window.matchHeightCallback = () => {
      window.setGridHeight('.js-grid-content-height'); 
    }
    window.matchHeightCallback();
}

let gridButton = document.querySelectorAll('.js-handle-grid-height');
if(gridButton.length > 0) {
  gridButton.forEach((button) => {
    button.addEventListener('click', () => {
      window.matchHeightCallback();
    })
  })
}

/* Complementary Products*/

class ComptFilter extends HTMLElement {
  connectedCallback() {
    this.limit = parseInt(this.dataset.limit) || 4;
    this.addEventListener('comp:loaded', () => this.filter());

    if (!window._compSubmitFix) {
      window._compSubmitFix = true;
      document.addEventListener('submit', e => {
        if (e.target.matches('form[data-type="add-to-cart-form"]')) {
          if (e.target.dataset.submitting) return e.preventDefault(), e.stopImmediatePropagation();
          e.target.dataset.submitting = '1';
          setTimeout(() => e.target.removeAttribute('data-submitting'), 1500);
        }
      }, true);
    }

    if (!window._compFetchPatched) {
      window._compFetchPatched = true;
      const originalFetch = window.fetch;
      
      window.fetch = function (...args) {
        const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url || '');
        if (/\/cart\/(add|change|update|clear)/i.test(url)) {
          const reqKey = url + (args[1]?.body || '');
          if (window._lastFetch === reqKey && Date.now() - (window._lastTime || 0) < 400) return new Promise(() => {});
          window._lastFetch = reqKey; window._lastTime = Date.now();
        }
        return originalFetch.apply(this, args).then(res => {
          if (/\/cart\/(add|change|update|clear)/i.test(url)) {
            clearTimeout(window._compTimer);
            window._compTimer = setTimeout(() => document.querySelectorAll('compt-filter').forEach(el => el.filter?.()), 800);
          }
          return res;
        });
      };
    }
  }

  async filter() {
    try {
      const cart = await fetch('/cart.js?t=' + Date.now()).then(r => r.json());
      const inCart = cart.items.map(i => String(i.product_id));
      let count = 0;
      
      this.querySelectorAll('swiper-slide[data-product-id]').forEach(slide => {
        if (inCart.includes(slide.dataset.productId)) slide.dataset.dismissed = '1';
        const show = slide.dataset.dismissed !== '1' && count < this.limit;
        slide.style.display = show ? '' : 'none';
        if (show) count++;
      });

      this.style.display = count ? 'block' : 'none';
      const swiper = this.querySelector('swiper-container')?.swiper;
      if (swiper?.initialized) {
        swiper.update();
        swiper.slideTo(0, 0, false);
      }
    } catch (e) { console.error(e); }
  }
}

if (!customElements.get('compt-filter')) customElements.define('compt-filter', ComptFilter);

/**
 * ADA: Swiper injects aria-controls IDs that live in shadow DOM (invalid for audits).
 * Ensure nav controls have labels and drop broken ARIA references.
 */
(function () {
  const SWIPER_NAV_SELECTOR = '.swiper-button-prev, .swiper-button-next';
  const videoPlayerTitle = 'Video player';

  const disableSwiperAutoA11y = () => {
    document.querySelectorAll('swiper-container').forEach((el) => {
      el.setAttribute('a11y-enabled', 'false');
    });
  };

  const fixSwiperNavAccessibility = () => {
    document.querySelectorAll(SWIPER_NAV_SELECTOR).forEach((el) => {
      el.removeAttribute('aria-controls');

      if (el.getAttribute('aria-disabled') === 'false') {
        el.removeAttribute('aria-disabled');
      }

      if (!el.getAttribute('aria-label')) {
        el.setAttribute(
          'aria-label',
          el.classList.contains('swiper-button-next') ? 'Next slide' : 'Previous slide'
        );
      }
    });
  };

  const ensureIframeTitles = () => {
    document.querySelectorAll('iframe:not([title])').forEach((iframe) => {
      if (
        iframe.id === 'klaviyo-bis-iframe' ||
        iframe.closest('form.klaviyo-form') ||
        iframe.closest('[data-testid^="klaviyo-form"]')
      ) {
        return;
      }
      iframe.setAttribute('title', videoPlayerTitle);
    });
  };

  const fixDecorativeBackgroundVideos = () => {
    const captionsSrc =
      window.themeAssets && window.themeAssets.emptyCaptionsVtt
        ? window.themeAssets.emptyCaptionsVtt
        : null;

    document
      .querySelectorAll('video.section__wrapper-background, .banner__background video, video.hero__bg')
      .forEach((video) => {
        video.querySelectorAll('img').forEach((img) => {
          if (!img.hasAttribute('alt')) {
            img.setAttribute('alt', '');
          }
        });

        if (captionsSrc && !video.querySelector('track[kind="captions"]')) {
          const track = document.createElement('track');
          track.kind = 'captions';
          track.label = 'English';
          track.srclang = 'en';
          track.src = captionsSrc;
          video.appendChild(track);
        }
      });
  };

  const runAccessibilityFixes = () => {
    disableSwiperAutoA11y();
    fixSwiperNavAccessibility();
    ensureIframeTitles();
    fixDecorativeBackgroundVideos();
  };

  runAccessibilityFixes();
  document.addEventListener('DOMContentLoaded', runAccessibilityFixes);
  document.addEventListener('shopify:section:load', runAccessibilityFixes);
  document.addEventListener('load', runAccessibilityFixes, true);

  document.addEventListener(
    'swiperafterinit',
    () => {
      fixSwiperNavAccessibility();
    },
    true
  );
})();
